import { NewZealand } from "./pages";

// SET THIS CONSTANT TO THE CORRECT COUNTRY
// THEN UPDATE "homepage" PROPERTY IN package.json
const APP_COUNTRY = "newzealand";

const vistaComponents = {
  newzealand: NewZealand,
};

const links = {
  newzealand: {
    tnc: "https://www.panasonic.com/nz/terms-of-use.html",
    pp: "https://www.panasonic.com/nz/privacy-policy.html",
    contact: "https://www.panasonic.co.nz/contact-us",
  },
};

const vistaPaths = {
  newzealand: "/space-solution/newzealand/newzealand_3d/index.htm",
};

const navLinks = [
  {
    country: "NewZealand",
    route: "/space-solution/newzealand",
  },
];

const interactiveContent = "/space-solution/newzealand/interactive_content/index.html";

const { tnc, pp, contact } = links[APP_COUNTRY];
const vistaUrl = vistaPaths[APP_COUNTRY];
const VistaComponent = vistaComponents[APP_COUNTRY];

const appConfig = {
  VistaComponent,
  tnc,
  pp,
  contact,
  vistaUrl,
  navLinks,
  interactiveContent
};

export { appConfig };
